import { httpClient } from '../http/httpClient'

export interface UpdateTabledata {
  name?: string
  percents?: number
  bonus?: number
  limit?: number
  order?: number
  valuesAndCommissions?: {
    value: number
    commission: number
    leaderCommission?: number
    max?: number
  }[]
}

export interface UpdateTableResponse {
  _id: string
  name: string
  percents: number
  bonus: number
}
export const updateTable = async (updateData: UpdateTabledata, id: string) => {
  const { data } = await httpClient
    .put<UpdateTableResponse>(`table/${id}`, updateData)
    .catch((error) => {
      throw error.response.data
    })

  return data
}
